import { useState } from "react";
import { Alert, Button, CircularProgress, Dialog, Divider, ThemeProvider } from "@mui/material";
import { AddOutlined, DeleteOutline, DownloadOutlined, FolderOutlined } from "@mui/icons-material";
import theme from "../../style/theme.jsx";
import { writeFile } from "../../functions/file-sys/write";
import { Mail } from "../../classes/mail.tsx";
import { db } from "../../firebase/firebase.js";
import { collection, doc, getCountFromServer, getDocs, limit, orderBy, query, startAfter } from "firebase/firestore";
import RenderMail from "../../widgets/mails/mail.tsx";
import { deleteDbDoc } from "../../firebase/firestore/functions.tsx";
import { RetValCode } from "../../classes/retval.tsx";
import MailDetailsView from "../../widgets/mails/mail-details.jsx";
import { LoadingPage, PageTitle } from "../../widgets/small-widgets.jsx";
import { navbarHeight } from "../../widgets/navbar.jsx";
import { useTranslation } from "react-i18next";

const optionsMargin = 40;

export default function LocalMails({}) {
    const { t } = useTranslation();

    const [localFile, setLocalFile] = useState(null); //dirHandle
    const [mails, setMails] = useState(null);
    const [mailsLength, setMailsLength] = useState(null);
    const [mailsJsonData, setMailsJsonData] = useState(null);

    const [amount, setAmount] = useState(10);

    const [msg, setMsg] = useState(null);

    const [loading, setLoading] = useState(false);
    const [total, setTotal] = useState(null);
    const [progress, setProgress] = useState(null);
    const [actual, setActual] = useState('');

    const [selected, setSelected] = useState(null);

    async function loadMails(reset=false) {
        const fileHandle = await localFile.getFileHandle('Mails.json');
        const json = await fileHandle.getFile();
        console.log(json);
        
        if (json.size === 0) {
            const data = {mails: [], length: 0};
            await writeFile(fileHandle, JSON.stringify(data));
            setMails([]);
            setMailsLength(0);
            setMailsJsonData([]);
        } else {
            const json_data = JSON.parse(await json.text());
            console.log(json_data);

            const newMails = [];

            const length = json_data.length;
            const startAt = reset?length:length-(mails != null && mails != undefined ? mails.length : 0);
            const targetAmount = amount <= startAt ? startAt-amount : 0;

            for (var i=startAt-1; i>=targetAmount; i--) {
                console.log(i);
                console.log(json_data.mails[i]);
                const mailFile = await localFile.getFileHandle(json_data.mails[i]);
                const file = await mailFile.getFile();
                const mailData = JSON.parse(await file.text());
                const mail = Mail.fromLocal(mailData, json_data.mails[i]);
                console.log(mail);
                newMails.push(mail);
            }

            setMails(reset?newMails:[...(mails != null && mails != undefined ? mails : []), ...newMails]); //TODO: import the first x mails 
            setMailsLength(json_data.length);
            setMailsJsonData(json_data.mails);
        }
    }
    
    if (localFile === null || localFile === undefined) {
        return <div>
            {msg != null ? <div style={{position:'fixed', right:'10px', top:`${navbarHeight+10}px`}}><Alert severity="warning" variant="outlined" onClose={() => {setMsg(null)}}>{msg}</Alert></div> : null}
            <ThemeProvider theme={theme}>
                <div style={{margin: '15px 10px'}}>
                    <PageTitle>{t('mails.locals.title')}</PageTitle>
                </div>
                <div style={{margin: '10px'}}>
                    <div style={{fontSize: 20, fontWeight: 500}}>{t('mails.locals.noFileSelected')}</div>
                    <div style={{height: 10}}/>
                    <div className="expand-width" style={{justifyContent: 'center'}}>
                        <div className="expand-width" style={{flexFlow: 'column', alignItems: 'center', marginTop: optionsMargin, marginBottom: optionsMargin}}>
                            <Button 
                                variant="outlined"
                                startIcon={<FolderOutlined/>}
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                onClick={async () => {
                                    try {
                                        const dirHandle = await window.showDirectoryPicker({mode: 'readwrite'});
                                        console.log(dirHandle);
                                        
                                        var len = 0;
                                        for await (const entry of dirHandle.values()) {
                                            len++;
                                        }

                                        if (len === 0) {
                                            setMsg(t('mails.locals.errors.emptyFolder'));
                                        } else {
                                            try {
                                                const fileHandle = await dirHandle.getFileHandle('Mails.json');
                                                console.log(fileHandle);
                                                setLocalFile(dirHandle);
                                            } catch (e) {
                                                setMsg(t('mails.locals.errors.noMailsFilde'));
                                                console.log(e);
                                            }
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                            >
                                {t('mails.locals.open')}
                            </Button>
                        </div>
                        <div style={{width: '5px'}}/>
                        <Divider orientation="vertical" flexItem/>
                        <div style={{width: '5px'}}/>
                        <div className="expand-width" style={{flexFlow: 'column', alignItems: 'center', marginTop: optionsMargin, marginBottom: optionsMargin}}>
                            <Button 
                                variant="outlined"
                                startIcon={<AddOutlined/>}
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                onClick={async () => {
                                    try {
                                        const dirHandle = await window.showDirectoryPicker({mode: 'readwrite'});
                                        console.log(dirHandle);
                                        
                                        var len = 0;
                                        for await (const entry of dirHandle.values()) {
                                            len++;
                                        }

                                        if (len === 0) {
                                            const fileHandle = await dirHandle.getFileHandle('Mails.json', { create: true });
                                            console.log(fileHandle);
                                            setLocalFile(dirHandle);
                                        } else {
                                            setMsg(t('mails.locals.errors.notEmptyFolder'));
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }}
                            >
                                {t('mails.locals.create')}
                            </Button>
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </div>
    }

    if (mails === null || mails === undefined) {
        loadMails();

        return <div>
            <LoadingPage/>
        </div>;
    }

    return <div>
        <ThemeProvider theme={theme}>
            <div style={{margin: '15px 10px'}}>
                <PageTitle>{t('mails.locals.title')}</PageTitle>
            </div>
            <Dialog open={loading} className="app-dialog">
                <div className="expand-width" style={{flexFlow: 'column', alignItems: 'center', padding: '20px'}}>
                    <h2>NO CIERRES LA VENTANA</h2>
                    <div style={{margin: 10, display: 'flex', flexFlow: 'column', alignItems: 'center'}}>
                        {typeof total === 'number' && typeof progress === 'number'
                            ? <>
                                <CircularProgress size="60px" variant="determinate" value={(progress/total)*100}/>
                                <div>{actual}</div>
                            </>
                            : <CircularProgress size="60px" />
                        }
                    </div>
                    <div style={{fontWeight:500}}>Mientras termina el proceso no cierres la ventana</div>
                </div>
            </Dialog>
            <Dialog open={selected != null} onClose={() => {setSelected(null)}}>
                {selected != null && selected!=undefined
                    ? <MailDetailsView mail={selected}/>
                    : null
                }
            </Dialog>
            <div className="expand-width" style={{alignItems: 'center', justifyContent: 'center'}}>
                <Button 
                    variant="outlined"
                    startIcon={<DownloadOutlined/>}
                    component="label"
                    sx={{margin: '10px'}}
                    role={undefined}
                    tabIndex={-1}
                    onClick={async () => {
                        setLoading(true);

                        const coll = collection(db, 'mail');
                        const count = await getCountFromServer(coll);

                        console.log(count.data().count);

                        setTotal(count.data().count+1);
                        setProgress(1);
                        var prog = 1;

                        const fileHandle = await localFile.getFileHandle('Mails.json');

                        var actualMails = mails;
                        var actualMailsLength = mailsLength;
                        var actualMailsJsonData = mailsJsonData;

                        var finished = false;

                        var lastMail = null;
                        while (!finished) {
                            setActual('Descargando mails...');
                            var q;
                            if (lastMail != null) {
                                q = query(collection(db, 'mail'), orderBy('delivery', 'asc'), startAfter(lastMail), limit(50));
                            } else {
                                q = query(collection(db, 'mail'), orderBy('delivery', 'asc'), limit(50));
                            }
                    
                            const mailsData = await getDocs(q);
                            lastMail = mailsData.docs[mailsData.docs.length-1];
                            for (var i=0; i<mailsData.docs.length; i++) {
                                prog++;
                                setProgress(prog);
                                const mail = Mail.fromJson(mailsData.docs[i].data(), mailsData.docs[i].id);
                                setActual(`Guardando mail ${mailsData.docs[i].id}...`);
                                console.log(mail);
                                console.log(mail.toJson());

                                const name = `mail-${actualMailsLength}.json`;
                                console.log(name);
                                const fileDataHandle = await localFile.getFileHandle(name, { create: true });
                                await writeFile(fileDataHandle, JSON.stringify(mail.toJson()));

                                actualMails = [mail, ...actualMails];
                                actualMailsLength++;
                                console.log(actualMailsLength);
                                actualMailsJsonData = [...actualMailsJsonData, name];

                                await writeFile(fileHandle, JSON.stringify({mails: actualMailsJsonData, length: actualMailsLength}));

                                setMails(actualMails);
                                setMailsLength(actualMailsLength);
                                setMailsJsonData(actualMailsJsonData);
                            }

                            if (progress >= total) finished = true;
                        }

                        await loadMails(true);

                        await new Promise(resolve => setTimeout(resolve, 100));

                        setTotal(null);
                        setProgress(null);
                        setActual('');
                        setLoading(false);
                    }}
                >
                    DESCARGAR MAILS
                </Button>
                {mails.length != 0? <Button 
                    variant="outlined"
                    startIcon={<DeleteOutline/>}
                    component="label"
                    sx={{margin: '10px'}}
                    role={undefined}
                    tabIndex={-1}
                    onClick={async () => {
                        setLoading(true);

                        const fileHandle = await localFile.getFileHandle('Mails.json');
                        const json = await fileHandle.getFile();
                        const fileData = JSON.parse(await json.text());

                        setTotal(fileData.length+1);
                        setProgress(1);

                        var prog = 1;

                        for (var i=0; i<fileData.length; i++) {
                            var actual = `Limpiando mail ${fileData.mails[i]}...`;
                            prog++;
                            setProgress(prog);
                            setActual(actual);

                            console.log(fileData.mails[i]);
                            const mailFileHandle = await localFile.getFileHandle(fileData.mails[i]);
                            const mailFile = await mailFileHandle.getFile();
                            const mailData = JSON.parse(await mailFile.text());

                            console.log(mailData.id);

                            actual = `${actual.replaceAll('...', '')} - ${mailData.id}...`;
                            setActual(actual);

                            const retVal = await deleteDbDoc(doc(db, 'mail', mailData.id));
                            if (retVal.getCode() !== RetValCode.OK) {
                                console.log(`No se ha eliminado el mail ${mailData.id}`);
                            }
                        }

                        await new Promise(resolve => setTimeout(resolve, 100));

                        setTotal(null);
                        setProgress(null);
                        setActual('');
                        setLoading(false);
                    }}
                >
                    LIMPIAR MAILS
                </Button> : null}
            </div>
            {mails.length === 0 ? <div style={{fontSize: 20, fontWeight: 500, textAlign:'center'}}>No hay mensajes guardados</div> : null}
            {mails.map((mail, index) => <RenderMail key={index} mail={mail} local={true} setSelected={(mail) => {setSelected(mail)}}/>)}
            {mailsLength != 0 && mails.length != mailsLength? <div className="expand-width" style={{flexFlow: 'column', alignItems: 'center', marginTop: 10}}><Button
                    variant="outlined"
                    component="label"
                    sx={{margin: '10px'}}
                    role={undefined}
                    tabIndex={-1}
                    onClick={() => loadMails(false)}
                >
                    CARGAR MÁS
                </Button></div> : null}
        </ThemeProvider> 
    </div>;
}